import { AfterContentInit, Component, ContentChildren, Directive, Input, QueryList } from '@angular/core';
import { ItemWithID } from '@sb/library/base';
import { FormFieldSelectItemComponent, IItemGroup } from './form-field-select-item.component';

@Directive({
    selector: 'lib-input-select-item-group',
})
export class FormFieldSelectItemGroupComponent<T extends ItemWithID> implements IItemGroup, AfterContentInit {
    @Input() name!: string;
    @ContentChildren(FormFieldSelectItemComponent, {descendants: true}) items!: QueryList<FormFieldSelectItemComponent<T>>;

    ngAfterContentInit(): void {
        this.items.forEach(item => item.group = this);
        this.items.changes.subscribe(_ => {
            this.items.forEach(item => item.group = this);
        });
    }
}
